import classNames from "classnames";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscPodcastCard.module.scss";

export interface AscPodcastCardProps {
  title: string;
  logoUrl?: string;
  author: string;
  loading?: boolean;
}

export default function AscPodcastCard({
  title,
  logoUrl,
  author,
  loading=false
}: AscPodcastCardProps) {
  return (
    <AscGenericCard
    loading={loading}
      className={classNames(styles.ground)}
      imageClassName={styles.cardImage}
      title={title}
      coverImageUrl={logoUrl}
      contentClassName={styles.cardContent}
    >
      {author}
    </AscGenericCard>
  );
}
